import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box, FormControlLabel, Menu, RadioGroup, Typography } from "@mui/material";
import React, { useState } from "react";

import { IconButton } from "@/Components/v2/atoms/Button";
import { Checkbox } from "@/Components/v2/atoms/Checkbox";
import { MenuItem } from "@/Components/v2/atoms/MenuItem";
import { Radio } from "@/Components/v2/atoms/Radio";

interface ChartSettingsProps {
  isAscending: boolean;
  setIsAscending: (isAscending: boolean) => void;
  filterInsufficientData: boolean;
  setFilterInsufficientData: (filterInsufficientData: boolean) => void;
}

const ChartSettings: React.FC<ChartSettingsProps> = ({
  isAscending,
  setIsAscending,
  filterInsufficientData,
  setFilterInsufficientData,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //TODO : Update this to use an ENUM
  const handleSortChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAscending(event.target.value === "true");
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterInsufficientData(event.target.checked);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          elevation: 2,
          sx: { width: 280, p: 2 },
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>Show:</Typography>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filterInsufficientData}
                  onChange={handleFilterChange}
                  name="filterInsufficientData"
                />
              }
              label="Items with insufficient sample size"
              sx={{
                "& .MuiFormControlLabel-label": {
                  whiteSpace: "normal",
                  lineHeight: 1.2,
                },
              }}
            />
          </MenuItem>
        </Box>
        <Box>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>Sort by:</Typography>
          <RadioGroup value={isAscending} onChange={handleSortChange}>
            <MenuItem>
              <FormControlLabel value={true} control={<Radio />} label="Ascending Order" />
            </MenuItem>
            <MenuItem>
              <FormControlLabel value={false} control={<Radio />} label="Descending Order" />
            </MenuItem>
          </RadioGroup>
        </Box>
      </Menu>
    </>
  );
};

export default ChartSettings;
